import { useState, useRef, useEffect } from "react";
import { fetchEmployeeProfilePicAPI } from "../services/employeeService";

/**
 * 🖼️ useEmployeeProfilePics Hook
 * يدير صور الموظفين والـ caching والـ loading states
 */
export function useEmployeeProfilePics(employees = []) {
  const [employeeProfilePics, setEmployeeProfilePics] = useState({});
  const [loadingPics, setLoadingPics] = useState(new Set());
  const picCacheRef = useRef(new Map());

  // ============== FETCH SINGLE PROFILE PICTURE ==============
  const fetchProfilePic = async (infinityCode) => {
    return fetchEmployeeProfilePicAPI(infinityCode, picCacheRef, loadingPics, setLoadingPics);
  };

  // ============== FETCH ALL PROFILE PICTURES IN BATCHES ==============
  useEffect(() => {
    const fetchAllProfilePics = async () => {
      // Disabled to speed up the system as requested by user
      return;
    };

    fetchAllProfilePics();
  }, [employees]);

  // ============== CLEANUP ON UNMOUNT ==============
  useEffect(() => {
    return () => {
      // Revoke all URLs to prevent memory leaks
      Object.values(employeeProfilePics).forEach(url => {
        if (url) URL.revokeObjectURL(url);
      });

      picCacheRef.current.forEach(url => {
        URL.revokeObjectURL(url);
      });

      picCacheRef.current.clear();
    };
  }, []);

  return {
    employeeProfilePics,
    setEmployeeProfilePics,
    loadingPics,
    setLoadingPics,
    picCacheRef,
    fetchProfilePic,
  };
}
